export default __webpack_public_path__ + "assets/icons/logo_white.60876c42.svg";